import { EffectCallback, useEffect } from 'react';

const useOnlyOnce = (effect: EffectCallback) => {
  useEffect(effect, []);
};

export default useOnlyOnce;
